// Define the configuration object
const config = {
    apiUrl: 'https://digital.allcasino.in:3000/',
    // apiUrl: 'http://localhost:3000/',
    radisUrl: 'https://85.159.214.160:9092/',
    bUrl: 'http://139.162.213.154:3000/',

    userTypes: ['Super Admin', 'Admin', 'Super Master', 'Master', 'Agent', 'User'],
    superAdmin: '692694cb1e768e2bd7fd4e6a',
    userTypesAlias: {
        'super_admin': 'Super Admin',
        'admin': 'Admin',
        'super_master': 'Super Master',
        'master': 'Master',
        'agent': 'Agent',
        'user': 'User'
    },

    // Dynamically assigned site code
    // sitecodes: 'P32',
    sitecodes: 'P56',

    videoUrl: {
        '7ud': 'https://tv.fireflybet.in/index.html?id=3058',
        'ab': 'https://route53.casinovid.in/dvideo/andarbahar/',
        'ltp': 'https://backlayexchange.com/new/oneday/',
        't20': 'https://backlayexchange.com/new/2020/',
        'dt20': 'https://tv.fireflybet.in/index.html?id=3059/',
        'aaa': 'https://shroute.casinovid.in/diamondvideo/dot.php?id=3056',
        '32c': 'https://shroute.casinovid.in/diamondvideo/dot.php?id=3034',
    },

    marketSarket: "http://marketsarket.in:3002/",

    casino_type_id: {
        '7ud': '1001',
        'ab': '1002',
        'ltp': '1003',
        't20': '1004',
        'dt20': '1005',
        '32c': '1007',
        'Lucky7A': '1008',
        '1daytp': '1009',
        'baccarat': '1010',
        'poker20A': '1011',
        'dt': '1012',
        '1daydt': '1013',
        'baccaratcard29': '1015',
        'mulfisteenpatti': '1016',
        'dtlteenpatti': '1017',
        'baccarat-A': '1018',
        'baccarat-C': '1019',
        'fdt': '1020',
        'fl7': '1021',
        'Lucky7B': '1022',
        '3cardJ': '1023',
        'casinowar': '1024',
        'instantworli': '1025',
        'bollywoodcasino': '1026',
        'imd': '1027',
        'aaa': '1028',
        'dtlA': '1029',
        'lottery': '1030',
        '20-20-race': '1031',
        'one-card-meter': '1032',
        '1-card-20-20': '1033',
        'trio': '1034',
        'kbc': '1035',
        'casino-meter': '1036',
        'point-tp': '1037',
        'joker-tp': '1038',
    },

    casino_video_id: {
        't20': 'GAME10',
        '1daytp': 'GAME13',
        'dt': 'GAME18',
        'dt20': 'GAME19',
        'Lucky7A': 'GAME30',
        'baccarat': 'GAME2',
        'baccarat-A': 'GAME2',
        'baccarat-C': 'GAME2',
        'poker20A': 'GAME7',
        '32c': 'GAME22',
        'dtlteenpatti': 'GAME4',
        'bollywoodcasino': 'GAME50',
    },

    casino_event_id: {
        '7ud': '98789',
        'ab': '87564',
        'ltp': '56767',
        't20': '56768',
        'dt20': '98790',
        'aaa': '98791',
        '32c': '56967'
    },

    site_url: 'https://galaxyexch.co/',

    casinoNav: [
        {
            'title': 'ALL',
            'category': 'popular',
            'cainso_type': 'ALL'
        },
        // {
        //     'title': 'MAC88',
        //     'category': 'MAC88',
        //     'cainso_type': 'WCO'
        // },
        // {
        //     'title': 'Fun Games',
        //     'category': 'Fun Games',
        //     'cainso_type': 'WCO'
        // },
        // {
        //     'title': 'Crash Games',
        //     'category': 'Crash Games',
        //     'cainso_type': 'WCO'
        // },
        {
            'title': 'Supernowa',
            'category': 'Supernowa',
            'cainso_type': 'WCO'
        },
        {
            'title': 'Spribe',
            'category': 'Spribe',
            'cainso_type': 'WCO'
        },
        {
            'title': 'Turbo Games',
            'category': 'Turbo Games',
            'cainso_type': 'WCO'
        },

        // {
        //     'title': 'Mac88 Virtuals',
        //     'category': 'Mac88 Virtuals',
        //     'cainso_type': 'WCO'
        // },
        {
            'title': 'Ezugi',
            'category': 'Ezugi',
            'cainso_type': 'WCO'
        },
        {
            'title': 'SA Gaming',
            'category': 'SA Gaming',
            'cainso_type': 'WCO'
        },
        {
            'title': 'Ho Gaming',
            'category': 'Ho Gaming',
            'cainso_type': 'WCO'
        },

        // {
        //     'title': 'JiLi',
        //     'category': 'JiLi',
        //     'cainso_type': 'WCO'
        // },
        {
            'title': 'Smart Soft',
            'category': 'Smart Soft',
            'cainso_type': 'WCO'
        },
        // {
        //     'title': 'KINGMAKER',
        //     'category': 'KINGMAKER',
        //     'cainso_type': 'WCO'
        // },
        {
            'title': 'BetGames.TV',
            'category': 'BetGames.TV',
            'cainso_type': 'WCO'
        },
        // {
        //     'title': 'Evolution Gaming',
        //     'category': 'Evolution Gaming',
        //     'cainso_type': 'WCO'
        // },
        {
            'title': ' OUR CASINO',
            'category': 'teen-patti',
            'cainso_type': ''
        },
        {
            'title': ' OUR VIRTUAL',
            'category': 'lucky-7',
            'cainso_type': ''
        },

        {
            'title': ' EVOLUTION',
            'category': 'dragon-tiger',
            'cainso_type': ''
        },

        {
            'title': ' TVBET ',
            'category': 'andar-bahar',
            'cainso_type': ''
        },
        {
            'title': ' BETGAME ',
            'category': 'poker',
            'cainso_type': ''
        },
        {
            'title': ' PLATINGAMES ',
            'category': 'bollywood',
            'cainso_type': ''
        },
        {
            'title': 'Other',
            'category': 'other',
            'cainso_type': ''
        },
    ],

    allCasino: [
        {
            'title': 'POINT TEEN PATTI',
            'path': '/other/Point Teen Patti-min.webp',
            'category': 'teen-patti',
            'id': '1037',
            'provider_code': "",
            'game_code': "",
            'type': '',
            'casino_type': ''
        },
        {
            'title': ' JOKER TEEN PATTI ',
            'path': '/other/Joker Teen Patti-min.webp',
            'category': 'teen-patti',
            'id': '1038',
            'provider_code': "",
            'game_code': "",
            'type': '',
            'casino_type': ''
        },
        {
            'title': 'MUFLIS TEEN PATTI',
            'path': '/other/MUFLISTEENPATTI.webp',
            'category': 'teen-patti',
            'id': "1016",
            'provider_code': "",
            'game_code': "",
            'type': '',
            'casino_type': ''
        },
        {
            'title': '1DAY TEEN PATTI',
            'path': '/other/I Day TeenPatti-min.webp',
            'category': 'teen-patti',
            'id': '1009',
            'provider_code': "",
            'game_code': "",
            'type': '',
            'casino_type': ''
        },
        {
            'title': 'DTL TEENPATTI',
            'path': '/other/DTL TEENPATTI.webp',
            'category': 'teen-patti',
            'id': '1017',
            'provider_code': "",
            'game_code': "",
            'type': '',
            'casino_type': ''
        },
        {
            'title': '20-20 TEENPATTI',
            'path': '/other/1_Day_Teen_Patti.webp',
            'category': 'teen-patti',
            'id': '1004',
            'provider_code': "",
            'game_code': "",
            'type': '',
            'casino_type': ''
        },
        {
            'title': '20-20 POKER - A',
            'path': '/other/poker-min (1).webp',
            'category': 'poker',
            'id': '1011',
            'provider_code': "",
            'game_code': "",
            'type': '',
            'casino_type': ''
        },
        {
            'title': '20-20 POKER - B',
            'path': '/other/20-20 Poker-min.webp',
            'category': 'poker',
            'id': '1011',
            'provider_code': "",
            'game_code': "",
            'type': '',
            'casino_type': ''
        },
        {
            'title': '29 CARD BACCARAT',
            'path': '/other/29 Baccarat-min.webp',
            'category': 'baccarat',
            'id': '1015',
            'provider_code': "",
            'game_code': "",
            'type': '',
            'casino_type': ''
        },
        // {
        //     'title': ' BACCARAT - A ',
        //     'path': '/other/BACCARAT-2.webp',
        //     'category': 'baccarat',
        //     'id': '1018',
        //     'provider_code': "",
        //     'game_code': "",
        //     'type': '',
        //     'casino_type': ''

        // },
        {
            'title': 'BACCARAT',
            'path': '/other/Baccarat-min.webp',
            'category': 'baccarat',
            'id': '1010',
            'provider_code': "",
            'game_code': "",
            'type': '',
            'casino_type': ''
        },
        // {
        //     'title': 'BACCARAT - C',
        //     'path': '/other/BACCARAT - C.webp',
        //     'category': 'baccarat',
        //     'url': 'BACCARAT-C',
        //     'id': '1019',
        //     'provider_code': "",
        //     'game_code': "",
        //     'type': '',
        //     'casino_type': ''
        // },
        {
            'title': 'DRAGON TIGER',
            'path': '/other/Dragon-Tiger-min.webp',
            'category': 'dragon-tiger',
            'id': '1012',
            'provider_code': "",
            'game_code': "",
            'type': '',
            'casino_type': ''
        },
        {
            'title': '20-20 DRAGON TIGER',
            'path': '/other/DragonTiger.webp',
            'category': 'dragon-tiger',
            'id': '1005',
            'provider_code': "",
            'game_code': "",
            'type': '',
            'casino_type': ''
        },
        // {
        //     'title': 'FAST DRAGON TIGER',
        //     'path': '/other/FAST DRAGON TIGER.webp',
        //     'category': 'dragon-tiger',
        //     'id': '1020',
        //     'provider_code': "",
        //     'game_code': "",
        //     'type': '',
        //     'casino_type': ''
        // },
        {
            'title': '1 DAY DRAGON TIGER',
            'path': '/other/1 Day Dragon-Tiger-min.webp',
            'category': 'dragon-tiger',
            'id': '1013',
            'provider_code': "",
            'game_code': "",
            'type': '',
            'casino_type': ''
        },
        {
            'title': 'DTL - A',
            'path': '/other/DTL-01 3-min.webp',
            'category': 'dragon-tiger',
            'id': '1029',
            'provider_code': "",
            'game_code': "",
            'type': '',
            'casino_type': ''
        },
        {
            'title': '32 CARDS - B',
            'path': '/other/32 cards-min-min.webp',
            'category': 'other',
            'id': '1007',
            'provider_code': "",
            'game_code': "",
            'type': '',
            'casino_type': ''
        },
        {
            'title': '32 CARDS - A',
            'path': '/other/32Cards.webp',
            'category': 'other',
            'id': '1007',
            'provider_code': "",
            'game_code': "",
            'type': '',
            'casino_type': ''
        },

        {
            'title': 'ANDAR BAHAR - A',
            'path': '/other/AndarBahar2-min-min.webp',
            'category': 'andar-bahar',
            'id': '1002',
            'provider_code': "",
            'game_code': "",
            'type': '',
            'casino_type': ''
        },
        {
            'title': 'ANDAR BAHAR - C',
            'path': '/other/AndarBahar3-min.webp',
            'category': 'andar-bahar',
            'id': '1002',
            'provider_code': "",
            'game_code': "",
            'type': '',
            'casino_type': ''
        },
        {
            'title': 'LUCKY 7 - A',
            'path': '/other/LUCKY7-A.webp',
            'category': 'lucky-7',
            'id': '1008',
            'provider_code': "",
            'game_code': "",
            'type': '',
            'casino_type': ''
        },
        {
            'title': 'FAST LUCKY - 7',
            'path': '/other/Fast lucky7-min.webp',
            'category': 'lucky-7',
            'id': '1021',
            'provider_code': "",
            'game_code': "",
            'type': '',
            'casino_type': ''
        },
        // {
        //     'title': 'LUCKY 7 - B',
        //     'path': '/other/LUCKY 7 - B.webp',
        //     'category': 'lucky-7',
        //     'url': 'LUCKY-7-B',
        //     'id': '1022',
        //     'provider_code': "",
        //     'game_code': "",
        //     'type': '',
        //     'casino_type': ''

        // },
        // {
        //     'title': '3 CARD JUDGEMENT',
        //     'path': '/other/3 CARD JUDGEMENT - A.webp',
        //     'category': 'other',
        //     'id': '1023',
        //     'provider_code': "",
        //     'game_code': "",
        //     'type': '',
        //     'casino_type': ''

        // },
        // {
        //     'title': 'Casino War',
        //     'path': '/other/CasinoWar-min.webp',
        //     'category': 'other',
        //     'id': '1024',
        //     'provider_code': "",
        //     'game_code': "",
        //     'type': '',
        //     'casino_type': ''

        // },
        {
            'title': 'INSTANT WORLI',
            'path': '/other/INSTANT WORLI.webp',
            'category': 'other',
            'id': '1025',
            'provider_code': "",
            'game_code': "",
            'type': '',
            'casino_type': ''
        },
        {
            'title': 'BOLLYWOOD CASINO',
            'path': '/other/BOLLYWOOD CASINO.webp',
            'category': 'bollywood',
            'id': '1026',
            'provider_code': "",
            'game_code': "",
            'type': '',
            'casino_type': ''
        },
        {
            'title': 'INA MINA DIKA',
            'path': '/other/INA MINA DIKA.webp',
            'category': 'bollywood',
            'id': '1027',
            'provider_code': "",
            'game_code': "",
            'type': '',
            'casino_type': ''
        },

        {
            'title': 'AMAR AKBAR',
            'path': '/other/AMAR AKBAR ANTHONY.webp',
            'category': 'bollywood',
            'id': '1028',
            'provider_code': "",
            'game_code': "",
            'type': '',
            'casino_type': ''
        },
        // {
        //     'title': 'LOTTERY',
        //     'path': '/other/Lottery 1-min.webp',
        //     'category': 'other',
        //     'id': '1030',
        //     'provider_code': "",
        //     'game_code': "",
        //     'type': '',
        //     'casino_type': ''
        // },
        // {
        //     'title': '20-20 CARD RACE',
        //     'path': '/other/20-20 CARD RACE.webp',
        //     'category': 'other',
        //     'url': '20-20-CARD-RACE',
        //     'id': '1031',
        //     'provider_code': "",
        //     'game_code': "",
        //     'type': '',
        //     'casino_type': ''

        // },
        // {
        //     'title': '1 CARD METER',
        //     'path': '/other/1 CARD METER.webp',
        //     'category': 'other',
        //     'url': '1-CARD-METER',
        //     'id': '1032',
        //     'provider_code': "",
        //     'game_code': "",
        //     'type': '',
        //     'casino_type': ''
        // },
        // {
        //     'title': '1 CARD 20-20',
        //     'path': '/other/1 Card-min.webp',
        //     'category': 'other',
        //     'id': '1033',
        //     'provider_code': "",
        //     'game_code': "",
        //     'type': '',
        //     'casino_type': ''
        // },
        // {
        //     'title': 'TRIO',
        //     'path': '/other/TRIO.webp',
        //     'category': 'other',
        //     'url': 'TRIO',
        //     'id': '1034',
        //     'provider_code': "",
        //     'game_code': "",
        //     'type': '',
        //     'casino_type': ''
        // },
        // {
        //     'title': 'KBC',
        //     'path': '/other/KBC-min.webp',
        //     'category': 'other',
        //     'url': 'KBC',
        //     'id': '1035',
        //     'provider_code': "",
        //     'game_code': "",
        //     'type': '',
        //     'casino_type': ''
        // },
        // {
        //     'title': 'CASINO METER',
        //     'path': '/other/CasinoMeter-min.webp',
        //     'category': 'other',
        //     'url': 'CASINO-METER',
        //     'id': '1036',
        //     'provider_code': "",
        //     'game_code': "",
        //     'type': '',
        //     'casino_type': ''
        // },
        {
            'title': 'EVOLUTION',
            'path': '/other/EVOLUTION.webp',
            'category': 'poker',
            'url': 'EVOLUTION',
            'provider_code': "",
            'game_code': "",
            'type': '',
            'casino_type': ''
        },
        // {
        //     'title': 'TVBET',
        //     'path': '/other/TVBET.webp',
        //     'category': 'poker',
        //     'provider_code': "",
        //     'game_code': "",
        //     'type': '',
        //     'casino_type': ''
        // },
        {
            'title': 'BETGAMES CASINO',
            'path': '/other/BETGAMES CASINO.webp',
            'category': 'poker',
            'provider_code': "",
            'game_code': "",
            'type': '',
            'casino_type': ''
        },
        {
            'title': 'EZUGI',
            'path': '/other/EZUGI.webp',
            'category': 'poker',
            'provider_code': "",
            'game_code': "",
            'type': '',
            'casino_type': ''
        },
        // {
        //     'title': 'VIMAAN',
        //     'path': '/other/',
        //     'category': 'other',
        //     'url': 'VIMAAN',
        //     'provider_code': "",
        //     'game_code': "",
        //     'type': '',
        //     'casino_type': ''
        // },

        {
            'title': 'Turbo Games',
            'path': 'https://img.jaipurapps.com/all-casino-img/other/tbg_hilo.webp',
            'category': 'Turbo Games',
            'provider_code': "QT",
            'game_code': "TRB-hilo",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Turbo Games',
            'path': 'https://img.jaipurapps.com/all-casino-img/blackjack/tbg_doubleroll.webp',
            'category': 'Turbo Games',
            'provider_code': "QT",
            'game_code': "TRB-doubleroll",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Turbo Games',
            'path': 'https://img.jaipurapps.com/all-casino-img/other/tbg_spinstrike.webp',
            'category': 'Turbo Games',
            'provider_code': "QT",
            'game_code': "TRB-spinstrike",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Turbo Games',
            'path': 'https://img.jaipurapps.com/all-casino-img/other/tbg_wicketblast.webp',
            'category': 'Turbo Games',
            'provider_code': "QT",
            'game_code': "TRB-wicketblast",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Turbo Games',
            'path': 'https://img.jaipurapps.com/all-casino-img/other/tbg_fastfielder.webp',
            'category': 'Turbo Games',
            'provider_code': "QT",
            'game_code': "TRB-fastfielder",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Turbo Games',
            'path': 'https://img.jaipurapps.com/all-casino-img/video-slot/tbg_bubbles.webp',
            'category': 'Turbo Games',
            'provider_code': "QT",
            'game_code': "TRB-bubbles",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Turbo Games',
            'path': 'https://img.jaipurapps.com/all-casino-img/other/tbg_fruittowers.webp',
            'category': 'Turbo Games',
            'provider_code': "QT",
            'game_code': "TRB-fruittowers",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Turbo Games',
            'path': 'https://img.jaipurapps.com/all-casino-img/other/tbg_tradingdice.webp',
            'category': 'Turbo Games',
            'provider_code': "QT",
            'game_code': "TRB-tradingdice",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Turbo Games',
            'path': 'https://img.jaipurapps.com/all-casino-img/other/tbg_turboplinko.webp',
            'category': 'Turbo Games',
            'provider_code': "QT",
            'game_code': "TRB-turboplinko",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Turbo Games',
            'path': 'https://img.jaipurapps.com/all-casino-img/other/bty_Mines-mines.webp',
            'category': 'Turbo Games',
            'provider_code': "QT",
            'game_code': "TRB-bookofmines",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Ezugi',
            'path': 'https://img.jaipurapps.com/all-casino-img/blackjack/ezg_blackjackgold5.webp',
            'category': 'Ezugi',
            'provider_code': "EZ",
            'game_code': "1",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Ezugi',
            'path': 'https://img.jaipurapps.com/all-casino-img/blackjack/ezg_blackjackplatinum1.webp',
            'category': 'Ezugi',
            'provider_code': "EZ",
            'game_code': "204",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Ezugi',
            'path': 'https://img.jaipurapps.com/all-casino-img/blackjack/rumba_blackjack_2.webp',
            'category': 'Ezugi',
            'provider_code': "EZ",
            'game_code': "411",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Ezugi',
            'path': 'https://img.jaipurapps.com/all-casino-img/blackjack/rumba_blackjack_3.webp',
            'category': 'Ezugi',
            'provider_code': "EZ",
            'game_code': "412",
            'type': '',
            'casino_type': 'WCO'
        },
        // {
        //     'title': 'Ezugi',
        //     'path': 'https://img.jaipurapps.com/all-casino-img/blackjack/ezg_unlimitedblackjack (1).webp',
        //     'category': 'Ezugi',
        //     'provider_code': "EZ",
        //     'game_code': "51",
        //     'type': '',
        //     'casino_type': 'WCO'
        // },
        {
            'title': 'Ezugi',
            'path': 'https://img.jaipurapps.com/all-casino-img/blackjack/ezg_blackjack_salonprive.webp',
            'category': 'Ezugi',
            'provider_code': "EZ",
            'game_code': "227",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Ezugi',
            'path': 'https://img.jaipurapps.com/all-casino-img/blackjack/blackjack_da_sorte.webp',
            'category': 'Ezugi',
            'provider_code': "EZ",
            'game_code': "260",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Ezugi',
            'path': 'https://img.jaipurapps.com/all-casino-img/blackjack/blackjack_da_sorte.webp',
            'category': 'Ezugi',
            'provider_code': "EZ",
            'game_code': "1000",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Ezugi',
            'path': 'https://img.jaipurapps.com/all-casino-img/roulette/ezg_speedautoroulette.webp',
            'category': 'Ezugi',
            'provider_code': "EZ",
            'game_code': "221000",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Ezugi',
            'path': 'https://img.jaipurapps.com/all-casino-img/roulette/diamond-roulette-thumb-v2.webp',
            'category': 'Ezugi',
            'provider_code': "EZ",
            'game_code': "221003",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Ezugi',
            'path': 'https://img.jaipurapps.com/all-casino-img/roulette/namaste-roulette-thumb-v2.webp',
            'category': 'Ezugi',
            'provider_code': "EZ",
            'game_code': "221005",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Ezugi',
            'path': 'https://img.jaipurapps.com/all-casino-img/roulette/turkish_roulette.webp',
            'category': 'Ezugi',
            'provider_code': "EZ",
            'game_code': "501000",
            'type': '',
            'casino_type': 'WCO'
        },
        // {
        //     'title': 'Ezugi',
        //     'path': 'https://img.jaipurapps.com/all-casino-img/roulette/ruletka russia.webp',
        //     'category': 'Ezugi',
        //     'provider_code': "EZ",
        //     'game_code': "5001",
        //     'type': '',
        //     'casino_type': 'WCO'
        // },
        {
            'title': 'Ezugi',
            'path': 'https://img.jaipurapps.com/all-casino-img/roulette/ezg_speedautoroulette.webp',
            'category': 'Ezugi',
            'provider_code': "EZ",
            'game_code': "221002",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Ezugi',
            'path': 'https://img.jaipurapps.com/all-casino-img/roulette/ezg_prestigeautoroulette.webp',
            'category': 'Ezugi',
            'provider_code': "EZ",
            'game_code': "221004",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Ezugi',
            'path': 'https://img.jaipurapps.com/all-casino-img/roulette/ezg_portomasocasinoroulette.webp',
            'category': 'Ezugi',
            'provider_code': "EZ",
            'game_code': "611000",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Ezugi',
            'path': 'https://img.jaipurapps.com/all-casino-img/roulette/oracle_roulette.webp',
            'category': 'Ezugi',
            'provider_code': "EZ",
            'game_code': "611001",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Ezugi',
            'path': 'https://img.jaipurapps.com/all-casino-img/roulette/oracle_roulette.webp',
            'category': 'Ezugi',
            'provider_code': "EZ",
            'game_code': "611003",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Ezugi',
            'path': 'https://img.jaipurapps.com/all-casino-img/roulette/ezg_marinacasinoroulette.webp',
            'category': 'Ezugi',
            'provider_code': "EZ",
            'game_code': "321000",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Ezugi',
            'path': 'https://img.jaipurapps.com/all-casino-img/roulette/ezg_ruleta-del-sol-thumb.webp',
            'category': 'Ezugi',
            'provider_code': "EZ",
            'game_code': "431000",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Ezugi',
            'path': 'https://img.jaipurapps.com/all-casino-img/roulette/ezg_ez_dealer_roulette.webp',
            'category': 'Ezugi',
            'provider_code': "EZ",
            'game_code': "481004",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Ezugi',
            'path': 'https://img.jaipurapps.com/all-casino-img/roulette/ezg_thai_roulette.webp',
            'category': 'Ezugi',
            'provider_code': "EZ",
            'game_code': "481001",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Ezugi',
            'path': 'https://img.jaipurapps.com/all-casino-img/roulette/ezg_ez_dealer_roulette_japanese.webp',
            'category': 'Ezugi',
            'provider_code': "EZ",
            'game_code': "481002",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Ezugi',
            'path': 'https://img.jaipurapps.com/all-casino-img/roulette/ez_dealer_roulette_mandarin.webp',
            'category': 'Ezugi',
            'provider_code': "EZ",
            'game_code': "481003",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Ezugi',
            'path': 'https://img.jaipurapps.com/all-casino-img/roulette/ultimate_roulette.webp',
            'category': 'Ezugi',
            'provider_code': "EZ",
            'game_code': "541000",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Ezugi',
            'path': 'https://img.jaipurapps.com/all-casino-img/roulette/roleta_da_sorte.webp',
            'category': 'Ezugi',
            'provider_code': "EZ",
            'game_code': "241000",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Ezugi',
            'path': 'https://img.jaipurapps.com/all-casino-img/roulette/vip_roulette.webp',
            'category': 'Ezugi',
            'provider_code': "EZ",
            'game_code': "611007",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Ezugi',
            'path': 'https://img.jaipurapps.com/all-casino-img/roulette/ez_dealer_roleta_brasileira.webp',
            'category': 'Ezugi',
            'provider_code': "EZ",
            'game_code': "481004",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Ezugi',
            'path': 'https://img.jaipurapps.com/all-casino-img/roulette/cricket_auto_roulette.webp',
            'category': 'Ezugi',
            'provider_code': "EZ",
            'game_code': "221007",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Ezugi',
            'path': 'https://img.jaipurapps.com/all-casino-img/poker/ezg_casinoholdem.webp',
            'category': 'Ezugi',
            'provider_code': "EZ",
            'game_code': "507000",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Ezugi',
            'path': 'https://img.jaipurapps.com/all-casino-img/teenpatti/teen_patti_227100.webp',
            'category': 'Ezugi',
            'provider_code': "EZ",
            'game_code': "227100",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Ezugi',
            'path': 'https://img.jaipurapps.com/all-casino-img/teenpatti/teen_patti_227100.webp',
            'category': 'Ezugi',
            'provider_code': "EZ",
            'game_code': "227101",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Ezugi',
            'path': 'https://img.jaipurapps.com/all-casino-img/teenpatti/ezg_onedayteenpatticlassic.webp',
            'category': 'Ezugi',
            'provider_code': "EZ",
            'game_code': "227103",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Ezugi',
            'path': 'https://img.jaipurapps.com/all-casino-img/baccarat/ezg_goldenbaccaratknockout.webp',
            'category': 'Ezugi',
            'provider_code': "EZ",
            'game_code': "120",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Ezugi',
            'path': 'https://img.jaipurapps.com/all-casino-img/baccarat/ezg_baccaratsuper6.webp',
            'category': 'Ezugi',
            'provider_code': "EZ",
            'game_code': "130",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Ezugi',
            'path': 'https://img.jaipurapps.com/all-casino-img/baccarat/no_commission_baccarat_170.webp',
            'category': 'Ezugi',
            'provider_code': "EZ",
            'game_code': "173",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Ezugi',
            'path': 'https://img.jaipurapps.com/all-casino-img/baccarat/baccarat_e.webp',
            'category': 'Ezugi',
            'provider_code': "EZ",
            'game_code': "100",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Ezugi',
            'path': 'https://img.jaipurapps.com/all-casino-img/baccarat/no_commission_baccarat_a.webp',
            'category': 'Ezugi',
            'provider_code': "EZ",
            'game_code': "172",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Ezugi',
            'path': 'https://img.jaipurapps.com/all-casino-img/baccarat/no_commission_baccarat_a.webp',
            'category': 'Ezugi',
            'provider_code': "EZ",
            'game_code': "228002",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Ezugi',
            'path': 'https://img.jaipurapps.com/all-casino-img/andarbahar/ezg_ultimate_andarbahar.webp',
            'category': 'Ezugi',
            'provider_code': "EZ",
            'game_code': "228000",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Ezugi',
            'path': 'https://img.jaipurapps.com/all-casino-img/andarbahar/andar_bahar_228000.webp',
            'category': 'Ezugi',
            'provider_code': "EZ",
            'game_code': "228100",
            'type': '',
            'casino_type': 'WCO'
        },

        {
            'title': 'Ezugi',
            'path': 'https://img.jaipurapps.com/all-casino-img/lucky-7/lucky7_228001.webp',
            'category': 'Ezugi',
            'provider_code': "EZ",
            'game_code': "228001",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Ezugi',
            'path': 'https://img.jaipurapps.com/all-casino-img/sicbo/sicbo-thumbnail.webp',
            'category': 'Ezugi',
            'provider_code': "EZ",
            'game_code': "224000",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Ezugi',
            'path': 'https://img.jaipurapps.com/all-casino-img/sicbo/ezg_ultimate_sicbo.webp',
            'category': 'Ezugi',
            'provider_code': "EZ",
            'game_code': "224100",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Ezugi',
            'path': 'https://img.jaipurapps.com/all-casino-img/other/cricket_war.webp',
            'category': 'Ezugi',
            'provider_code': "EZ",
            'game_code': "45100",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Spribe',
            'path': 'https://img.jaipurapps.com/all-casino-img/lucky-7/sbe_keno.webp',
            'category': 'Spribe',
            'provider_code': "SPB",
            'game_code': "keno",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Spribe',
            'path': 'https://img.jaipurapps.com/all-casino-img/lucky-7/sbe_roulette.webp',
            'category': 'Spribe',
            'provider_code': "SPB",
            'game_code': "mini-roulette",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Spribe',
            'path': 'https://img.jaipurapps.com/all-casino-img/lucky-7//sbe_hilo.webp',
            'category': 'Spribe',
            'provider_code': "SPB",
            'game_code': "hi-lo",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Spribe',
            'path': 'https://img.jaipurapps.com/all-casino-img/lucky-7/sbe_dice.webp',
            'category': 'Spribe',
            'provider_code': "SPB",
            'game_code': "dice",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Spribe',
            'path': 'https://img.jaipurapps.com/all-casino-img/lucky-7/sbe_mines1.webp',
            'category': 'Spribe',
            'provider_code': "SPB",
            'game_code': "mines",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Spribe',
            'path': 'https://img.jaipurapps.com/all-casino-img/lucky-7/sbe_plinko.webp',
            'category': 'Spribe',
            'provider_code': "SPB",
            'game_code': "plinko",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Spribe',
            'path': 'https://img.jaipurapps.com/all-casino-img/lucky-7/sbe_goal1.webp',
            'category': 'Spribe',
            'provider_code': "SPB",
            'game_code': "goal",
            'type': '',
            'casino_type': 'WCO'
        },

        {
            'title': 'Spribe',
            'path': 'https://img.jaipurapps.com/all-casino-img/lucky-7/sbe_hotline.webp',
            'category': 'Spribe',
            'provider_code': "SPB",
            'game_code': "hotline",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Spribe',
            'path': 'https://img.jaipurapps.com/all-casino-img/avitor-crash/sbe_aviator1.webp',
            'category': 'Spribe',
            'provider_code': "SPB",
            'game_code': "aviator",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Smart Soft',
            'path': 'https://img.jaipurapps.com/all-casino-img/video-slot/sms_wild_jungle.webp',
            'category': 'Smart Soft',
            'provider_code': "SMTSG",
            'game_code': "Jungles",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Smart Soft',
            'path': 'https://img.jaipurapps.com/all-casino-img/video-slot/geniesbonanza.webp',
            'category': 'Smart Soft',
            'provider_code': "SMTSG",
            'game_code': "GeniesBonanza",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Smart Soft',
            'path': 'https://img.jaipurapps.com/all-casino-img/video-slot/foxy_20.webp',
            'category': 'Smart Soft',
            'provider_code': "SMTSG",
            'game_code': "FoxyHot20",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Smart Soft',
            'path': 'https://img.jaipurapps.com/all-casino-img/video-slot/wilds_gods.webp',
            'category': 'Smart Soft',
            'provider_code': "SMTSG",
            'game_code': "WildsAndGods",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Smart Soft',
            'path': 'https://img.jaipurapps.com/all-casino-img/video-slot/sms_samurai.webp',
            'category': 'Smart Soft',
            'provider_code': "SMTSG",
            'game_code': "Samurai",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Smart Soft',
            'path': 'https://img.jaipurapps.com/all-casino-img/video-slot/sms_burning_ice_40.webp',
            'category': 'Smart Soft',
            'provider_code': "SMTSG",
            'game_code': "BlazingHot40",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Smart Soft',
            'path': 'https://img.jaipurapps.com/all-casino-img/video-slot/sms_vampires.webp',
            'category': 'Smart Soft',
            'provider_code': "SMTSG",
            'game_code': "Vampires",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Smart Soft',
            'path': 'https://img.jaipurapps.com/all-casino-img/video-slot/sms_multi_hot_5.webp',
            'category': 'Smart Soft',
            'provider_code': "SMTSG",
            'game_code': "MultiHotWays",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Smart Soft',
            'path': 'https://img.jaipurapps.com/all-casino-img/other/rower-x.webp',
            'category': 'Smart Soft',
            'provider_code': "SMTSG",
            'game_code': "TowerX",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Smart Soft',
            'path': 'https://img.jaipurapps.com/all-casino-img/other/crash_duelx.webp',
            'category': 'Smart Soft',
            'provider_code': "SMTSG",
            'game_code': "TugOfWar",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Smart Soft',
            'path': 'https://img.jaipurapps.com/all-casino-img/baccarat/smashx.webp',
            'category': 'Smart Soft',
            'provider_code': "SMTSG",
            'game_code': "SmashX",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Smart Soft',
            'path': 'https://img.jaipurapps.com/all-casino-img/baccarat/sms_jetx3.webp',
            'category': 'Smart Soft',
            'provider_code': "SMTSG",
            'game_code': "JetX3",
            'type': '',
            'casino_type': 'WCO'
        },

        {
            'title': 'Smart Soft',
            'path': 'https://img.jaipurapps.com/all-casino-img/baccarat/sms_baloon.webp',
            'category': 'Smart Soft',
            'provider_code': "SMTSG",
            'game_code': "Balloon",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Smart Soft',
            'path': 'https://img.jaipurapps.com/all-casino-img/other/sms_roll_x.webp',
            'category': 'Smart Soft',
            'provider_code': "SMTSG",
            'game_code': "RollX",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'BetGames.TV',
            'path': 'https://img.jaipurapps.com/all-casino-img/lucky-7/bgt_lucky7.webp',
            'category': 'BetGames.TV',
            'provider_code': "QT",
            'game_code': "BTV-lucky7",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'BetGames.TV',
            'path': 'https://img.jaipurapps.com/all-casino-img/lucky-7/bgt_diceduel.webp',
            'category': 'BetGames.TV',
            'provider_code': "QT",
            'game_code': "BTV-diceduel",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'BetGames.TV',
            'path': 'https://img.jaipurapps.com/all-casino-img/lucky-7/bgt_warofbets.webp',
            'category': 'BetGames.TV',
            'provider_code': "QT",
            'game_code': "40BTV-warofbets0057",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'BetGames.TV',
            'path': 'https://img.jaipurapps.com/all-casino-img/lucky-7/bgt_lucky6.webp',
            'category': 'BetGames.TV',
            'provider_code': "QT",
            'game_code': "BTV-lucky6",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'BetGames.TV',
            'path': 'https://img.jaipurapps.com/all-casino-img/lucky-7/bgt_lucky5.webp',
            'category': 'BetGames.TV',
            'provider_code': "QT",
            'game_code': "BTV-lucky5",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'BetGames.TV',
            'path': 'https://img.jaipurapps.com/all-casino-img/poker/bgt_poker6.webp',
            'category': 'BetGames.TV',
            'provider_code': "QT",
            'game_code': "BTV-6poker",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'BetGames.TV',
            'path': 'https://img.jaipurapps.com/all-casino-img/poker/bgt_bet-on-poker.webp',
            'category': 'BetGames.TV',
            'provider_code': "QT",
            'game_code': "BTV-betonpoker",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'BetGames.TV',
            'path': 'https://img.jaipurapps.com/all-casino-img/32cards/bgt_wheeloffortune.webp',
            'category': 'BetGames.TV',
            'provider_code': "QT",
            'game_code': "BTV-wheeloffortune",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'BetGames.TV',
            'path': 'https://img.jaipurapps.com/all-casino-img/baccarat/bgt_baccarat.webp',
            'category': 'BetGames.TV',
            'provider_code': "QT",
            'game_code': "BTV-baccarat",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Supernowa',
            'path': 'https://img.jaipurapps.com/new-casino-img/Supernova/32-Cards.webp',
            'category': 'Supernowa',
            'provider_code': "SN",
            'game_code': "VC32",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Supernowa',
            'path': 'https://img.jaipurapps.com/new-casino-img/Supernova/Akbar-Romeo-Walter.webp',
            'category': 'Supernowa',
            'provider_code': "SN",
            'game_code': "ARW",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Supernowa',
            'path': 'https://img.jaipurapps.com/new-casino-img/Supernova/Andar-Bahar.webp',
            'category': 'Supernowa',
            'provider_code': "SN",
            'game_code': "AB",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Supernowa',
            'path': 'https://img.jaipurapps.com/new-casino-img/Supernova/Andar-Bahar-Yellow.webp',
            'category': 'Supernowa',
            'provider_code': "SN",
            'game_code': "AB",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Supernowa',
            'path': 'https://img.jaipurapps.com/new-casino-img/Supernova/Baccarat.webp',
            'category': 'Supernowa',
            'provider_code': "SN",
            'game_code': "BAC",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Supernowa',
            'path': 'https://img.jaipurapps.com/new-casino-img/Supernova/Classic-Andar-Bahar.webp',
            'category': 'Supernowa',
            'provider_code': "SN",
            'game_code': "ABC",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Supernowa',
            'path': 'https://img.jaipurapps.com/new-casino-img/Supernova/dragon-tiger.webp',
            'category': 'Supernowa',
            'provider_code': "SN",
            'game_code': "DT7M",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Supernowa',
            'path': 'https://img.jaipurapps.com/new-casino-img/Supernova/Goas-Andar-Bahar.webp',
            'category': 'Supernowa',
            'provider_code': "SN",
            'game_code': "AB2",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Supernowa',
            'path': 'https://img.jaipurapps.com/new-casino-img/Supernova/king-race.webp',
            'category': 'Supernowa',
            'provider_code': "SN",
            'game_code': "VCR",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Supernowa',
            'path': 'https://img.jaipurapps.com/new-casino-img/Supernova/Lucky-7.webp',
            'category': 'Supernowa',
            'provider_code': "SN",
            'game_code': "UD7",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Supernowa',
            'path': 'https://img.jaipurapps.com/new-casino-img/Supernova/Muflis-teenpatti.webp',
            'category': 'Supernowa',
            'provider_code': "SN",
            'game_code': "MTP7M",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Supernowa',
            'path': 'https://img.jaipurapps.com/new-casino-img/Supernova/Teen-Patti-2020.webp',
            'category': 'Supernowa',
            'provider_code': "SN",
            'game_code': "VTP20",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Supernowa',
            'path': 'https://img.jaipurapps.com/new-casino-img/Supernova/1-RNG-Teen-Patti_1654174277274.199-(1).webp',
            'category': 'Supernowa',
            'provider_code': "SN",
            'game_code': "VTP",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Supernowa',
            'path': 'https://img.jaipurapps.com/new-casino-img/Supernova/2-RNG-Baccarat_1654174122016.387.webp',
            'category': 'Supernowa',
            'provider_code': "SN",
            'game_code': "VBAC",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Supernowa',
            'path': 'https://img.jaipurapps.com/new-casino-img/Supernova/3-RNG-Dragon-Tiger_1654174186400.0757.webp',
            'category': 'Supernowa',
            'provider_code': "SN",
            'game_code': "VDT",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Supernowa',
            'path': 'https://img.jaipurapps.com/new-casino-img/Supernova/5-RNG-Worli-Matka_1654174294949.6729.webp',
            'category': 'Supernowa',
            'provider_code': "SN",
            'game_code': "VWM",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Supernowa',
            'path': 'https://img.jaipurapps.com/new-casino-img/Supernova/6-RNG-ARW_1654174098050.0847.webp',
            'category': 'Supernowa',
            'provider_code': "SN",
            'game_code': "VARW",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Supernowa',
            'path': 'https://img.jaipurapps.com/new-casino-img/Supernova/8-RNG-32Cards_1654174090231.0889.webp',
            'category': 'Supernowa',
            'provider_code': "SN",
            'game_code': "VC32",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Supernowa',
            'path': 'https://img.jaipurapps.com/new-casino-img/Supernova/10-RNG-Lucky-7_1654174238397.5676-(1).webp',
            'category': 'Supernowa',
            'provider_code': "SN",
            'game_code': "VUD7",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Supernowa',
            'path': 'https://img.jaipurapps.com/new-casino-img/Supernova/20-RNG-casino-queen_1654174167060.9355.webp',
            'category': 'Supernowa',
            'provider_code': "SN",
            'game_code': "RCQ20",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Supernowa',
            'path': 'https://img.jaipurapps.com/new-casino-img/Supernova/21-RNG-Joker_1654174209032.3987.webp',
            'category': 'Supernowa',
            'provider_code': "SN",
            'game_code': "VJKR",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Supernowa',
            'path': 'https://img.jaipurapps.com/new-casino-img/Supernova/23-RNG-queen_1654174151635.7964.webp',
            'category': 'Supernowa',
            'provider_code': "SN",
            'game_code': "RCQ",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Ho Gaming',
            'path': 'https://img.jaipurapps.com/new-casino-img/hogaming/C1-Speed-Baccarat.webp',
            'category': 'Ho Gaming',
            'provider_code': "QT",
            'game_code': "HOG-c1speedbaccarat",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Ho Gaming',
            'path': 'https://img.jaipurapps.com/new-casino-img/hogaming/C2-Speed-Baccarat.webp',
            'category': 'Ho Gaming',
            'provider_code': "QT",
            'game_code': "HOG-c2speedbaccarat",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Ho Gaming',
            'path': 'https://img.jaipurapps.com/new-casino-img/hogaming/C3-speed-Baccarat.webp',
            'category': 'Ho Gaming',
            'provider_code': "QT",
            'game_code': "HOG-c3speedbaccarat",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Ho Gaming',
            'path': 'https://img.jaipurapps.com/new-casino-img/hogaming/C4-Speed-baccarat.webp',
            'category': 'Ho Gaming',
            'provider_code': "QT",
            'game_code': "HOG-c4immersivespeedbaccarat",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Ho Gaming',
            'path': 'https://img.jaipurapps.com/new-casino-img/hogaming/C5-Speed-baccarat.webp',
            'category': 'Ho Gaming',
            'provider_code': "QT",
            'game_code': "HOG-c5speedbaccarat",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Ho Gaming',
            'path': 'https://img.jaipurapps.com/new-casino-img/hogaming/C7-Speed-Baccarat.webp',
            'category': 'Ho Gaming',
            'provider_code': "QT",
            'game_code': "HOG-c7speedbaccarat",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Ho Gaming',
            'path': 'https://img.jaipurapps.com/new-casino-img/hogaming/C8-Baccarat.webp',
            'category': 'Ho Gaming',
            'provider_code': "QT",
            'game_code': "HOG-c8baccarat",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Ho Gaming',
            'path': 'https://img.jaipurapps.com/new-casino-img/hogaming/C9-Baccarat.webp',
            'category': 'Ho Gaming',
            'provider_code': "QT",
            'game_code': "HOG-c9baccarat",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Ho Gaming',
            'path': 'https://img.jaipurapps.com/new-casino-img/hogaming/DT2-DragonTiger.webp',
            'category': 'Ho Gaming',
            'provider_code': "QT",
            'game_code': "HOG-dt2dragontiger",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Ho Gaming',
            'path': 'https://img.jaipurapps.com/new-casino-img/hogaming/J2-Blackjack.webp',
            'category': 'Ho Gaming',
            'provider_code': "QT",
            'game_code': "HOG-j2blackjack",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Ho Gaming',
            'path': 'https://img.jaipurapps.com/new-casino-img/hogaming/N1-Baccarat.webp',
            'category': 'Ho Gaming',
            'provider_code': "QT",
            'game_code': "HOG-n1baccarat",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Ho Gaming',
            'path': 'https://img.jaipurapps.com/new-casino-img/hogaming/N1-Blackjack.webp',
            'category': 'Ho Gaming',
            'provider_code': "QT",
            'game_code': "HOG-n1blackjack",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Ho Gaming',
            'path': 'https://img.jaipurapps.com/new-casino-img/hogaming/N1-Roulette.webp',
            'category': 'Ho Gaming',
            'provider_code': "QT",
            'game_code': "HOG-n1roulette",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Ho Gaming',
            'path': 'https://img.jaipurapps.com/new-casino-img/hogaming/N2-Speed-Baccarat.webp',
            'category': 'Ho Gaming',
            'provider_code': "QT",
            'game_code': "HOG-n2speedbaccarat",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Ho Gaming',
            'path': 'https://img.jaipurapps.com/new-casino-img/hogaming/N3-Baccarat.webp',
            'category': 'Ho Gaming',
            'provider_code': "QT",
            'game_code': "HOG-n3baccarat",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Ho Gaming',
            'path': 'https://img.jaipurapps.com/new-casino-img/hogaming/N4-Immersive-Bacarat.webp',
            'category': 'Ho Gaming',
            'provider_code': "QT",
            'game_code': "HOG-n4immersivebaccarat",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Ho Gaming',
            'path': 'https://img.jaipurapps.com/new-casino-img/hogaming/S1-Roulette.webp',
            'category': 'Ho Gaming',
            'provider_code': "QT",
            'game_code': "HOG-s1roulette",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'Ho Gaming',
            'path': 'https://img.jaipurapps.com/new-casino-img/hogaming/S2-Roulette.webp',
            'category': 'Ho Gaming',
            'provider_code': "QT",
            'game_code': "HOG-s2roulette",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'SA Gaming',
            'path': 'https://img.jaipurapps.com/new-casino-img/sagaming/Baarrat-C01.webp',
            'category': 'SA Gaming',
            'provider_code': "QT",
            'game_code': "SAG-baccaratc01",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'SA Gaming',
            'path': 'https://img.jaipurapps.com/new-casino-img/sagaming/M-adhar-bahar.webp',
            'category': 'SA Gaming',
            'provider_code': "QT",
            'game_code': "SAG-mandarbahar",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'SA Gaming',
            'path': 'https://img.jaipurapps.com/new-casino-img/sagaming/M-Dragon-Tiger.webp',
            'category': 'SA Gaming',
            'provider_code': "QT",
            'game_code': "SAG-mdragontiger",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'SA Gaming',
            'path': 'https://img.jaipurapps.com/new-casino-img/sagaming/M-blackjack.webp',
            'category': 'SA Gaming',
            'provider_code': "QT",
            'game_code': "SAG-mblackjack",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'SA Gaming',
            'path': 'https://img.jaipurapps.com/new-casino-img/sagaming/M-Roulette.webp',
            'category': 'SA Gaming',
            'provider_code': "QT",
            'game_code': "SAG-mroulette",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'SA Gaming',
            'path': 'https://img.jaipurapps.com/new-casino-img/sagaming/M-Sicbo.webp',
            'category': 'SA Gaming',
            'provider_code': "QT",
            'game_code': "SAG-msicbo",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'SA Gaming',
            'path': 'https://img.jaipurapps.com/new-casino-img/sagaming/M-Teenpatti-2020.webp',
            'category': 'SA Gaming',
            'provider_code': "QT",
            'game_code': "SAG-mteenpatti2020",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'SA Gaming',
            'path': 'https://img.jaipurapps.com/new-casino-img/sagaming/Pok-Deng.webp',
            'category': 'SA Gaming',
            'provider_code': "QT",
            'game_code': "SAG-mpokdeng",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'SA Gaming',
            'path': 'https://img.jaipurapps.com/new-casino-img/sagaming/Speed-Baarrat-C08.webp',
            'category': 'SA Gaming',
            'provider_code': "QT",
            'game_code': "SAG-speedbaccaratc08",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'SA Gaming',
            'path': 'https://img.jaipurapps.com/new-casino-img/sagaming/Baarrat-c02.webp',
            'category': 'SA Gaming',
            'provider_code': "QT",
            'game_code': "SAG-baccaratc02",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'SA Gaming',
            'path': 'https://img.jaipurapps.com/new-casino-img/sagaming/Baarrat-C03.webp',
            'category': 'SA Gaming',
            'provider_code': "QT",
            'game_code': "SAG-baccaratc03",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'SA Gaming',
            'path': 'https://img.jaipurapps.com/new-casino-img/sagaming/Baarrat-C04.webp',
            'category': 'SA Gaming',
            'provider_code': "QT",
            'game_code': "SAG-baccaratc04",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'SA Gaming',
            'path': 'https://img.jaipurapps.com/new-casino-img/sagaming/Baarrat-C05.webp',
            'category': 'SA Gaming',
            'provider_code': "QT",
            'game_code': "SAG-baccaratc05",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'SA Gaming',
            'path': 'https://img.jaipurapps.com/new-casino-img/sagaming/Baarrat-C06.webp',
            'category': 'SA Gaming',
            'provider_code': "QT",
            'game_code': "SAG-baccaratc06",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'SA Gaming',
            'path': 'https://img.jaipurapps.com/new-casino-img/sagaming/Baarrat-C07.webp',
            'category': 'SA Gaming',
            'provider_code': "QT",
            'game_code': "SAG-baccaratc07",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'SA Gaming',
            'path': 'https://img.jaipurapps.com/new-casino-img/sagaming/Baccarat-D01.webp',
            'category': 'SA Gaming',
            'provider_code': "QT",
            'game_code': "SAG-baccaratd01",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'SA Gaming',
            'path': 'https://img.jaipurapps.com/new-casino-img/sagaming/Baccarat-D02.webp',
            'category': 'SA Gaming',
            'provider_code': "QT",
            'game_code': "SAG-baccaratd02",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'SA Gaming',
            'path': 'https://img.jaipurapps.com/new-casino-img/sagaming/Baccarat-D03.webp',
            'category': 'SA Gaming',
            'provider_code': "QT",
            'game_code': "SAG-baccaratd03",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'SA Gaming',
            'path': 'https://img.jaipurapps.com/new-casino-img/sagaming/Baccarat-D04.webp',
            'category': 'SA Gaming',
            'provider_code': "QT",
            'game_code': "SAG-baccaratd04",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'SA Gaming',
            'path': 'https://img.jaipurapps.com/new-casino-img/sagaming/Baccarat-D05.webp',
            'category': 'SA Gaming',
            'provider_code': "QT",
            'game_code': "SAG-baccaratd05",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'SA Gaming',
            'path': 'https://img.jaipurapps.com/new-casino-img/sagaming/Baccarat-D06.webp',
            'category': 'SA Gaming',
            'provider_code': "QT",
            'game_code': "SAG-baccaratd06",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'SA Gaming',
            'path': 'https://img.jaipurapps.com/new-casino-img/sagaming/Baccarat-D07.webp',
            'category': 'SA Gaming',
            'provider_code': "QT",
            'game_code': "SAG-baccaratd07",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'SA Gaming',
            'path': 'https://img.jaipurapps.com/new-casino-img/sagaming/Speed-Bacarrat-E08.webp',
            'category': 'SA Gaming',
            'provider_code': "QT",
            'game_code': "SAG-speedbaccarate09",
            'type': '',
            'casino_type': 'WCO'
        },
        {
            'title': 'SA Gaming',
            'path': 'https://img.jaipurapps.com/new-casino-img/sagaming/Speed-Bacarrat-E09.webp',
            'category': 'SA Gaming',
            'provider_code': "QT",
            'game_code': "SAG-speedbaccarate09",
            'type': '',
            'casino_type': 'WCO'
        },
    ]

};

// Define site codes and superAdmin for different domains
const domainConfig = {
    'aura444.us': { sitecodes: 'P32', superAdmin: '67b4a2b66e3e1d68dcba3764' },
    'aura444.me': { sitecodes: 'P32', superAdmin: '67b4a2b66e3e1d68dcba3764' },
    'ptsexch.in': { sitecodes: 'P41', superAdmin: '67dc3aa032961547e8a94c90' },
    'master444.bet': { sitecodes: 'P40', superAdmin: '67d97a2232961547e8a94c20' },
    'aura-444.com': { sitecodes: 'P48', superAdmin: '6831d550e7829c6f8791fc50' },
    'sky.jaipurapps.com': { sitecodes: 'P56', superAdmin: '692694cb1e768e2bd7fd4e6a' },
};

// Get the current hostname
const currentDomain = window.location.hostname;

// Assign the site code and superAdmin dynamically based on the domain
if (domainConfig[currentDomain]) {
    config.sitecodes = domainConfig[currentDomain].sitecodes;
    config.superAdmin = domainConfig[currentDomain].superAdmin;
}

// Export the entire config object
export default config;

// Export other constants separately
export const SOCKET_URL = 'wss://ws.operator.buzz:7072/';
export const DEFAULT_CURRENCY = 'PBU';
export const SITE_URL = 'https://galaxyexch.co/';
